import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { preloadListSalesChannels } from '@/api/react-query'

// `q` backs the SearchField in the list; the full list is fetched once and filtered client-side.
const searchSchema = z.object({
	q: z.string().optional()
})

export const Route = createFileRoute('/_authenticated/settings/sales-channels')({
	validateSearch: searchSchema,
	loader: async ({ context }) => await preloadListSalesChannels(context, {}),
	staticData: { crumb: ({ context: { L } }) => L.SalesChannels.Title() }
})
